jQuery(document).ready(function($) {
  
  function getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  };

	$(document).on('click', '.load-more-button', function() {
 
		var button = $(this),
		   post_data = {
			'action': 'load-more-posts',
			'query': ajax_load_more_params.query_vars // get params from the wp_localize_script() function
		};

    post_data['page'] = button.attr('data-page');
    ajax_load_more_params.current_page = parseInt(post_data['page']);
 
    var tribe_bar_entertainment_venue_field = getUrlParameter('tribe-bar-entertainment-venue-field');
    var tribe_bar_date = getUrlParameter('tribe-bar-date');
    var tribe_bar_search = getUrlParameter('tribe-bar-search');
    if (tribe_bar_entertainment_venue_field != '') {
      post_data['tribe-bar-entertainment-venue-field'] = tribe_bar_entertainment_venue_field;
    }
    if (tribe_bar_date != '') {
      post_data['tribe-bar-date'] = tribe_bar_date;
    }
    if (tribe_bar_search != '') {
      post_data['tribe-bar-search'] = tribe_bar_search;
    }
 
		$.ajax({
			url : global_vars.ajax_url, // ajax handler
			data : post_data,
			type : 'POST',
			beforeSend : function(xhr) {
				button.text('Loading...'); // change the button text, you can also add a preloader image
			},
			success : function(data) {
				if ( data ) {
					var dataParse = JSON.parse(ajax_load_more_params.query_vars);
					var postType = dataParse.post_type;

					if ( postType == 'tribe_events' || postType == 'wscp_entertainment' || postType == 'wscp_casino_venue' ) {
						button.text( 'Load More' );

            var dummy_container = $('<div id="dummy-container">'+data+'</div>');
            var last_date = $('h2.tribe-events-list-separator-month:last span').html();
            // console.log(last_date);
            if (last_date !== undefined) {
              // check if the first month/year is the same in the response and delete it if it is
              var first_date_in_response = dummy_container.find('h2.tribe-events-list-separator-month:first span').html();
              
              // console.log(first_date_in_response);
              if (first_date_in_response !== undefined && first_date_in_response == last_date) {
                // console.log('match found');
                // console.log(data);
                dummy_container.find('h2.tribe-events-list-separator-month:first').remove();
                data = dummy_container.filter("#dummy-container").html();
                // console.log(data);
              }
            }

						$('.tribe-events-loop').append(data); // insert new posts
					} else {
					  button.text( 'Load More' ).parent().prev('.row').append(data); // insert new posts
					}

  				var current_page = parseInt(ajax_load_more_params.current_page) + 1;
  				var max_pages = parseInt(button.data('max-pages'));

  				ajax_load_more_params.max_page = max_pages;

  				ajax_load_more_params.current_page = current_page;
          button.attr('data-page', current_page);

  				if ( current_page == max_pages ) {
						$('.load-more-wrapper').remove(); // if last page, remove the button
					}
					// you can also fire the "post-load" event here if you use a plugin that requires it
					// $( document.body ).trigger( 'post-load' );
				} else {
					$('.load-more-wrapper').remove(); // if no data, remove the button as well
				}

				trigger_window_resize();
			}
		});
	});

	$(document).on('click', '.site-search-load-more-button', function(e) {
    
    e.preventDefault();
    
		var elem = $(this);
    var container_id = elem.data('results-container-id');
    var selected_post_types = $('input[name=search-form-post-types]:checked').map(function(){ return $(this).val(); }).get();
    
    // need to add a dummy post type to fool Events plugin
    if (selected_post_types.length == 1 )
      selected_post_types.push("dummy");
    
		$.ajax({
			url : global_vars.ajax_url, // ajax handler
      data : {
        'action': 'process_search',
        'data_type': 'html',
        'q': $('form[name=search-form] input[name=q]').val(),
        'selected_post_types': selected_post_types,
        'page': elem.data('page')
      },
			type : 'GET',
			beforeSend : function(xhr) {
				elem.text('Loading...'); // change the button text, you can also add a preloader image
			},
			success : function(data) {
				$('.load-more-wrapper').remove();

				if ( data ) {
          
					$('#' + container_id ).append( data );


					trigger_window_resize();

				}
			}
		});
    
	});
  
  $(document).on('click', '.search-form-post-types-btn-group', function(e) {
 
    var selected_post_types = $('input[name=search-form-post-types]:checked').map(function(){ return $(this).val(); }).get();

    // need to add a dummy post type to fool Events plugin
    if (selected_post_types.length == 1 )
      selected_post_types.push("dummy");

    var container_id = 'site-search-results';

    // console.log( selected_post_types );
    
		$.ajax({
			url : global_vars.ajax_url, // ajax handler
      data : {
        'action': 'process_search',
        'data_type': 'html',
        'q': $('form[name=search-form] input[name=q]').val(),
        'selected_post_types': selected_post_types,
        'page': 1
      },
			type : 'GET',
			beforeSend : function(xhr) {
				// show some animation?
			},
			success : function(data) {
				if ( data ) {
          
          $('#' + container_id ).html( data );

					trigger_window_resize();
          
				}
			}
		});
    
    
  });


	$(document).on('click', '.casino-games-load-more-button', function(e) {
    
    e.preventDefault();
    
		var elem = $(this);
    var container_id = elem.data('results-container-id');
    var page_num = parseInt(elem.attr('data-page'));
    var max_pages = parseInt(elem.attr('data-max-pages'));
    var form_id = '#' + elem.data('form-id');

    var form_data = {
      'action': 'process_casino_games_search',
      'wscp_casino_game_category': $(form_id + ' select[name=wscp_casino_game_category]').val(),
      'wscp_casino_game_venue': $(form_id + ' select[name=wscp_casino_game_venue]').val(),
      's': $(form_id + ' input[name=s]').val(),
      'data_type': 'html',
      'page': page_num,
    };

		$.ajax({
			url : global_vars.ajax_url, // ajax handler
      data : form_data,
			type : 'GET',
			beforeSend : function(xhr) {
				elem.text('Loading...'); // change the button text, you can also add a preloader image
			},
			success : function(data) {

        
        elem.text( 'Load More' );
        elem.attr( 'data-page',  page_num+1);

				var current_page = page_num;
        
        // console.log('current_page: ' + current_page);
        // console.log('max_pages: ' + max_pages);
        
        ajax_load_more_params.max_page = max_pages;
        
        ajax_load_more_params.current_page = current_page;

				if ( current_page == max_pages ) {
					elem.parent().remove(); // if last page, remove the button
				}
        
				if ( data ) {
          $('#' + container_id ).append( data );

          trigger_window_resize();

				} else {
					elem.parent().remove(); // if last page, remove the button
				}
			}
		});
    
	});

	$(document).on('click', '.promotions-load-more-button', function(e) {
    
    e.preventDefault();
    
		var elem = $(this);
    var container_id = elem.data('results-container-id');
    var page_num = elem.attr('data-page');
    var form_id = '#' + elem.data('form-id');

    var data = {
      'action': 'process_promotions_search',
      'start_date': $(form_id + ' input[name=start_date]').val(),
      'wscp_promotion_category': $(form_id + ' select[name=wscp_promotion_category]').val(),
      's': $(form_id + ' input[name=s]').val(),
      'data_type': 'html',
      'page': page_num,
    };

		$.ajax({
			url : global_vars.ajax_url, // ajax handler
      data : data,
			type : 'GET',
			beforeSend : function(xhr) {
				elem.text('Loading...'); // change the button text, you can also add a preloader image
			},
			success : function(data) {

        
		        elem.text( 'Load More' );
		        elem.attr( 'data-page',  parseInt(page_num)+1);

						var current_page = parseInt(ajax_load_more_params.current_page) + 1;
		        var max_pages = parseInt(ajax_load_more_params.max_page);
		        
		        ajax_load_more_params.max_page = max_pages;
		        
		        ajax_load_more_params.current_page = current_page;

				if ( current_page == max_pages ) {
					elem.parent().remove(); // if last page, remove the button
				}
        
				if ( data ) {
          $('#' + container_id ).append( data );

          trigger_window_resize();
				
				} else {
					elem.parent().remove(); // if last page, remove the button
				}
			}
		});
    
	});


});
